export default __webpack_public_path__ + "static/media/111.8ee78cb5.png";